__turbopack_context__.v({
  "container": "TemplateViewer-module-scss-module__1fqewq__container",
  "iframe": "TemplateViewer-module-scss-module__1fqewq__iframe",
  "mobile": "TemplateViewer-module-scss-module__1fqewq__mobile",
  "mobileOnWixEditor": "TemplateViewer-module-scss-module__1fqewq__mobileOnWixEditor",
  "onMobileDevice": "TemplateViewer-module-scss-module__1fqewq__onMobileDevice",
  "studioRoot": "TemplateViewer-module-scss-module__1fqewq__studioRoot",
  "tablet": "TemplateViewer-module-scss-module__1fqewq__tablet",
});
